import React from 'react';
import i18n from '../../../../i18n';
import { Button, Input, Select } from 'antd';
import { useWarehouseContext } from '../../../../contexts/WarehouseContext';
import { SiteType } from '../../../../graphql/types/SiteType';
import { t } from '../../../../i18n';
import DateTimeRangeFilterItem from '../../../delivery/components/DateTimeRangeFilterItem';

interface LocationManagementFilterProps {
    filters: {
        locationNo: string;
        warehouseId?: number;
        buildTimeStart: string | null;
        buildTimeEnd: string | null;
    };
    setFilters: (filters: any) => void;
    warehouseOptions: { value: number; label: string }[];
}

const LocationManagementFilter: React.FC<LocationManagementFilterProps> = ({
    filters,
    setFilters,
    warehouseOptions
}) => {
    const { currentWarehouse } = useWarehouseContext();

    const handleTimeRangeChange = (dates: [string | null, string | null] | null) => {
        if (dates && dates[0] && dates[1]) {
            setFilters({
                ...filters,
                buildTimeStart: dates[0],
                buildTimeEnd: dates[1]
            });
        } else {
            setFilters({
                ...filters,
                buildTimeStart: null,
                buildTimeEnd: null
            });
        }
    };

    const isForeign = !i18n.language?.startsWith('zh');
    const labelClassName = isForeign
        ? 'mb-1 whitespace-nowrap font-bold'
        : 'mr-2 whitespace-nowrap font-bold';
    const rowClassName = isForeign
        ? 'flex flex-col'
        : 'flex items-center';

    return (
        <div className="flex flex-nowrap items-start gap-6">
            {/* 库位号 */}
            <div className={`${rowClassName} flex-1 min-w-[140px]`}>
                <span className={labelClassName}>
                    {t('wms.locationManagement.filters.locationNo')}
                </span>
                <Input
                    value={filters.locationNo}
                    onChange={(e) => {
                        const nextValue = e.target.value.replace(/\s+/g, '');
                        setFilters({ ...filters, locationNo: nextValue });
                    }}
                    onKeyDown={(event) => {
                        if (event.key === ' ') {
                            event.preventDefault();
                        }
                    }}
                    placeholder={t('wms.locationManagement.filters.locationNoPlaceholder')}
                    className="w-full"
                    allowClear
                />
            </div>

            {/* 仓库 */}
            <div className={`${rowClassName} flex-1 min-w-[140px]`}>
                <span className={labelClassName}>
                    {t('wms.locationManagement.filters.warehouse')}
                </span>
                {Number(currentWarehouse?.siteType) === SiteType.HUB ? (
                    <Select
                        value={filters.warehouseId}
                        onChange={(value) => setFilters({ ...filters, warehouseId: value })}
                        placeholder={t('wms.locationManagement.filters.warehouseAll')}
                        className="w-full"
                        allowClear
                        options={warehouseOptions}
                    />
                ) : (
                    <Input
                        value={currentWarehouse?.name || ''}
                        disabled
                        className="w-full"
                    />
                )}
            </div>

            {/* 创建时间 */}
            <DateTimeRangeFilterItem
                label={t('wms.locationManagement.filters.createTime')}
                value={filters.buildTimeStart && filters.buildTimeEnd ? [filters.buildTimeStart, filters.buildTimeEnd] : null}
                onChange={handleTimeRangeChange}
                placeholder={[
                    t('wms.locationManagement.filters.startTime'),
                    t('wms.locationManagement.filters.endTime')
                ]}
                size="middle"
                className={`${isForeign ? 'flex flex-col items-start' : 'flex items-center'} flex-1 min-w-[220px]`}
                spanClassName={isForeign ? 'text-gray-500 mb-1 whitespace-nowrap' : 'text-gray-500 mr-2 whitespace-nowrap'}
            />
        </div>
    );
};

export default LocationManagementFilter;

